import { atomWithStorage } from 'jotai/utils';

import type { InvitationVerification } from '@/types/referral-outbound-center/models/InvitationVerification';

export const invitationVerificationsAtom = atomWithStorage<
  Record<string, InvitationVerification>
>('roc-invitation-verifications', {}, undefined, { getOnInit: true });
